import events from '../../events.yaml';
export const mutateTrackerInstance = trackerInstance => {
  return trackerInstance.clone({
    events,
    preserveTrackerEvents: false,
    trackerName: 'developer-docs-shared-components'
  });
};